import React from "react";
import { useLocation } from "react-router-dom";
import { Package, FileText, Receipt, Repeat, Sparkles } from "lucide-react";

const MAP = {
  "/catalogue": { icon: Package, title: "Catalogue produits & services", desc: "Gérez vos prestations, tarifs et TVA, réutilisables dans vos devis et factures." },
  "/devis": { icon: FileText, title: "Devis", desc: "Éditeur de devis multi-lignes, remises, échéanciers, signature et PDF automatique." },
  "/factures": { icon: Receipt, title: "Factures", desc: "Factures manuelles ou générées depuis un devis, avoirs, relances et encaissement Stripe." },
  "/abonnements": { icon: Repeat, title: "Abonnements & MRR", desc: "Tableau de bord MRR / ARR, projection 12 mois et échéanciers récurrents." },
};

export default function BillingComingSoon() {
  const { pathname } = useLocation();
  const m = MAP[pathname] || MAP["/devis"];
  const Icon = m.icon;
  return (
    <div className="h-full overflow-y-auto bg-background flex items-center justify-center p-8" data-testid="billing-coming-soon">
      <div className="max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-klein/12 text-klein flex items-center justify-center mx-auto mb-5"><Icon size={30} /></div>
        <h1 className="font-cabinet font-black text-2xl tracking-tight mb-2">{m.title}</h1>
        <p className="text-zinc-400 text-sm mb-5">{m.desc}</p>
        <div className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-amber-400/12 text-amber-500 text-sm font-medium">
          <Sparkles size={15} /> Module PREMIUM — intégration en cours
        </div>
      </div>
    </div>
  );
}
